import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const SplitTextTitle = () => {
	const block = document.querySelectorAll(".split-text-title");
	if (!block) {
		return;
	}
	gsap.registerPlugin(ScrollTrigger);
	const isMobile = window.innerWidth < 768;

	block.forEach((title) => {
		// const rect = title.getBoundingClientRect();
		// if (rect.top > window.innerHeight) {}

		Splitting({ target: title, by: "chars" });

		const initAnimation = () => {
			const TLSplitTitle = gsap.timeline({
				scrollTrigger: {
					trigger: title,
					start: `top ${isMobile ? "90%" : "85%"}`,
					end: `+=${isMobile ? title.offsetHeight : title.offsetHeight * 2}`,
					scrub: true
				}
			});
			TLSplitTitle.to(title.querySelectorAll(".char"), { y: "0%", opacity: 1, stagger: { each: 0.05 } });
		};
		initAnimation();

		document.addEventListener("split-text-title-refresh", (e) => {
			initAnimation();
		});
	});
};

export default SplitTextTitle;
